export default class Sound {
    constructor(src) {
        this.sound = document.createElement("audio");
        this.sound.src = src;
        this.sound.setAttribute("preload", "auto");
        this.sound.setAttribute("loop", true);
        this.sound.setAttribute("controls", "none");
        this.sound.style.display = "none";
        document.body.appendChild(this.sound);
        this.paused = true;
    }

    play() {
        this.sound.play();
        this.paused = false;
    }
    stop() {
        this.sound.pause();
        this.paused = true;
    }
    toggle() {
        if (this.sound.paused) {
            this.sound.play();
            return true
        } else {
            this.sound.pause();
            return false
        }
    }
    remove() {
        this.sound.remove();
    }

    set src(value) {
        this.sound.src = value;
    }
}